import { trackGaEvent } from "../util/gtm";

const trackClick = (evt: Event): void => {
    if (evt.currentTarget instanceof HTMLAnchorElement) {
        trackGaEvent("on_external_link_clicked", {
            href: evt.currentTarget.attributes.getNamedItem("href")?.value,
            customer_id: evt.currentTarget.dataset.customerid,
            customer_name: evt.currentTarget.dataset.customername,
            business_id: evt.currentTarget.dataset.businessid,
            business_name: evt.currentTarget.dataset.businessname,
            container: evt.currentTarget.dataset.container
        });
    }
};

const trackKpi = (evt: Event) => {
    if (evt.currentTarget instanceof HTMLElement) {
        trackGaEvent("on_kpi", {
            action: evt.currentTarget.dataset.action,
            item_id: evt.currentTarget.dataset.itemid,
            in_section: evt.currentTarget.dataset.inSection,
            item_type: evt.currentTarget.dataset.itemtype,
            item_category: evt.currentTarget.dataset.itemcategory,
            variant: evt.currentTarget.dataset.variant,
            customer_name: evt.currentTarget.dataset.customername,
            customer_id: evt.currentTarget.dataset.customerid,
            business_name: evt.currentTarget.dataset.businessname,
            business_id: evt.currentTarget.dataset.businessid,
            placement: evt.currentTarget.dataset.placement,
            container: evt.currentTarget.dataset.container,
            container_variant: evt.currentTarget.dataset.containervariant,
        });
    }
};

const hookLinkTracking = (el: ParentNode) => {
    const allLinks = el.querySelectorAll('a[href*="https"],a[href*="http"]');

    allLinks.forEach((a) => {
        a.addEventListener("click", trackClick);
    });
};

const hookKpiTracking = (el: ParentNode) => {
    const elements = el.querySelectorAll<HTMLElement>(
        "[ga-track-kpi]"
    );

    elements.forEach((element) => {
        element.addEventListener("click", trackKpi);
    });
};

let impressionObserver: IntersectionObserver | null = null;

if ("IntersectionObserver" in window) {
    impressionObserver = new IntersectionObserver(
        function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    const element = entry.target as HTMLElement;

                    trackGaEvent("on_impression", {
                        item_id: element.dataset.itemid,
                        in_section: element.dataset.inSection,
                        item_type: element.dataset.itemtype,
                        item_category: element.dataset.itemcategory,
                        variant: element.dataset.variant,
                        customer_name: element.dataset.customername,
                        customer_id: element.dataset.customerid,
                        business_name: element.dataset.businessname,
                        business_id: element.dataset.businessid,
                        placement: element.dataset.placement,
                        container: element.dataset.container,
                        container_variant: element.dataset.containervariant,
                    });

                    impressionObserver?.unobserve(element);
                }
            });
        },
        { threshold: 0.5 }
    );
}

const hookImpressionTracking = (el: ParentNode) => {
    const elements = el.querySelectorAll<HTMLElement>("[ga-track-impression]");

    elements.forEach((element) => {
        impressionObserver?.observe(element);
    });
};

export const hookDefaultGATracking = (el: ParentNode) => {
    hookLinkTracking(el);
    hookKpiTracking(el);
    hookImpressionTracking(el);
};
